import { render, staticRenderFns } from "./TrashNEOHistorical.vue?vue&type=template&id=68dd91e2&scoped=true&"
import script from "./TrashNEOHistorical.vue?vue&type=script&lang=js&"
export * from "./TrashNEOHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd91e2",
  null
  
)

export default component.exports